import React, { useMemo } from "react";

import GroupedTeam from "./GroupedTeam";
import { useGenericWorkflowStatus } from "../../../../reactQuery/workflows";
import { useTeams } from "../../../../reactQuery/teams";
import { buildGroupedTeams } from "../../utils/myTaskUtils";

function Team({ groupingUser }) {
  const { genericWorkflowStatus: data } = useGenericWorkflowStatus();
  const { teams: teamQuery } = useTeams();
  const teams = useMemo(
    () =>
      buildGroupedTeams(
        groupingUser,
        teamQuery?.data?.data?.responseData || []
      ),
    [groupingUser, teamQuery]
  );

  return (
    <div className="user-separate-board">
      {teams.map((team, idx) =>
        team?.users.length ? (
          <GroupedTeam key={`grouped-team-${idx}`} team={team} data={data} />
        ) : (
          ""
        )
      )}
      {teams.length === 0 && (
        <div className="loader-center">
          <p>Select User</p>
        </div>
      )}
    </div>
  );
}

export default Team;
